import * as actionTypes from '../constants';
import service from '../utils/services';

export const showLoader = () => ({
  type: actionTypes.SHOW_LOADER
});

export const hideLoader = () => ({
  type: actionTypes.HIDE_LOADER
});

export const setToken = token => ({
  type: actionTypes.SET_TOKEN,
  token
});

export const setUser = user => ({
  type: actionTypes.RECEIVE_USER,
  user
});

export const showError = error => ({
  type: actionTypes.SHOW_ERROR,
  error
});

export const hideError = () => ({
  type: actionTypes.HIDE_ERROR
});

export const getProfile = () => dispatch => {
  dispatch(showLoader());
  service.getProfile().then(response => {
    dispatch(setUser(response.data));
    dispatch(hideLoader());
  });
};

const receiveStates = states => ({
  type: actionTypes.RECEIVE_STATES,
  states
});

export const getStates = () => dispatch => {
  service.getStates().then(response => {
    dispatch(receiveStates(response.data));
  });
};

export const saveWaiverSigned = (isSigned, profile, callback) => dispatch => {
  dispatch(showLoader());
  service
    .saveWaiver(isSigned)
    .then(resp => {
      if (isSigned) {
        setSignUpStep(2);
      }
      return resp;
    })
    .then(response => {
      if (response.status === 200) {
        dispatch(setUser(profile));
        dispatch(hideError());
        if (callback) callback();
      }
    })
    .catch(error => {
      handleRequestError(dispatch, error.response);
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const saveAvatar = (AvatarURI, profile, callback) => dispatch => {
  dispatch(showLoader());
  service
    .saveAvatar(AvatarURI)
    .then(response => {
      if (response.status === 200) {
        dispatch(setUser(profile));
        dispatch(hideError());
      }
    })
    .catch(({ response }) => {
      handleRequestError(dispatch, response);
    })
    .finally(() => {
      if (callback) callback();
      dispatch(hideLoader());
    });
};

const setUserDefaultPayment = (id, profile, dispatch) => {
  const Payments = profile.Payments.map(p => {
    p.IsDefault = p.Id === id;
    return p;
  });
  const user = {
    ...profile,
    Payments
  };
  dispatch(setUser(user));
};

export const setDefaultCard = (id, profile) => dispatch => {
  const currentDefaultId = profile.Payments.find(p => p.IsDefault).Id;
  setUserDefaultPayment(id, profile, dispatch);
  service.setDefaultCard(id).catch(({ response }) => {
    setUserDefaultPayment(currentDefaultId, profile, dispatch);
    const { Message: message } = response.data;
    dispatch(showError({ message }));
  });
};

export const showCropper = () => ({
  type: actionTypes.SHOW_CROPPER
});

export const hideCropper = () => ({
  type: actionTypes.HIDE_CROPPER
});

export const receiveCropperImage = imageDetails => ({
  type: actionTypes.RECEIVE_CROPPER_IMAGE,
  imageDetails
});

export const cropperZoom = zoom => ({
  type: actionTypes.CROPPER_ZOOM,
  zoom
});

const handleRequestError = (dispatch, response) => {
  const { Message: message = 'There was an error.' } = response.data;
  dispatch(showError({ message }));
};

export const cancelMembership = (reason, id, successCallback) => dispatch => {
  dispatch(showLoader());
  service
    .cancelMembership(reason, id)
    .then(() => {
      service.getProfile().then(response => {
        dispatch(setUser(response.data));
        successCallback();
      });
    })
    .catch(({ response }) => {
      handleRequestError(dispatch, response);
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const setSignUpStep = (step, callback) => {
  return service.setSignUpStep(step).then(resp => resp);
};



// WEBPACK FOOTER //
// ./src/actions/index.js